import { Box, Typography,useMediaQuery } from '@mui/material'
import React from 'react'


function TitleComponent({ Title }) {
  const isMobile = useMediaQuery('(max-width:600px)');
  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-start",
        paddingLeft: isMobile ? "16px" : "24px"
      }}
    >
      <Typography 
        sx={{
          color: "#000000",
          fontSize: isMobile? "0.7rem" : "1rem",
          fontWeight: "500",
          fontFamily: "'Amiko', 'Segoe UI', 'Oxygen', 'Ubuntu', sans-serif",
        }}
      >
        {Title}
      </Typography>
    </Box>

  )
}

export default TitleComponent
